export default __webpack_public_path__ + "static/media/small-sprinter.e58be454.jpg";